import React from 'react';
import './About.css';
import { motion } from 'framer-motion';
import AboutChef1Img from '../../utils/images/about_chef1.jpg';
import AboutChef2Img from '../../utils/images/about_chef2.jpg';
import ImageGallery from '../../components/ImageGallery/ImageGallery';
import Reviews from '../../components/Reviews/Reviews';

function About() {
  return (
    <div className='about-page'>
      <header className='height-50 mt-5'>
        <motion.div 
          className="container h-100 d-flex align-items-center justify-content-center"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className='text-light'>Sobre O OM Grill</h1>
        </motion.div>
      </header>

      <div className="container my-5">
        <p>O restaurante OM Grill oferece um ambiente acolhedor e encantador, sendo um local convidativo tanto para refeições casuais como para reuniões especiais. Com interiores cuidadosamente concebidos e um serviço simpático, os clientes podem desfrutar de um menu diversificado com deliciosos pratos grelhados, bem como de uma seleção de bebidas que melhoram a experiência gastronómica. Perfeito para uma noite descontraída ou uma celebração memorável, o OM Grill cria um ambiente encantador que faz com que os hóspedes se sintam em casa.</p>
        <p></p>

        <div className="row">
          <motion.div 
            className="col-lg-6"
            initial={{ opacity: 0, x: -300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src={AboutChef1Img} className='img-fluid my-4' alt="" />
          </motion.div>
          <motion.div 
            className="col-lg-6"
            initial={{ opacity: 0, x: 350 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src={AboutChef2Img} className='img-fluid my-4' alt="" />
          </motion.div>
        </div>

        <p>Orgulhamo-nos de oferecer uma experiência gastronómica única que combina a arte do sushi com a riqueza dos pratos tradicionais. A nossa equipa culinária, inspirada nos diversos sabores do Japão e de outros locais, prepara cada prato com cuidado, utilizando apenas os ingredientes mais frescos. Junte-se a nós numa viagem culinária que celebra a inovação e a tradição, tudo num ambiente acolhedor que o faz sentir em casa!</p>
      </div>

      <div className="bg-dark text-light py-1">
        <ImageGallery />
      </div>

      <div className="my-5">
        <Reviews />
      </div>
    </div>
  )
}

export default About;